
export default function Footer() {
  return (
    <footer className="bg-dark rounded-t-3xl mt-20 px-4 sm:px-8 py-12 sm:py-16 relative overflow-hidden">
      <div className="absolute inset-0 flex items-end justify-center opacity-30 pointer-events-none">
        <span className="text-[100px] sm:text-[200px] font-black text-[#1a1a1a]" style={{ color: '#2a2a2a' }}>EHT</span>
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 relative z-10">
        <div>
          <h3 className="text-white text-2xl sm:text-4xl font-bold mb-4 leading-tight">
            PRÊT À PRENDRE<br />RENDEZ-VOUS ?
          </h3>
        </div>

        <div>
          <h4 className="text-white text-lg sm:text-xl uppercase tracking-wider mb-4 sm:mb-6">Navigation</h4>
          <ul className="space-y-3 sm:space-y-4">
            <li>
              <Link to="/" className="text-gray-custom hover:text-secondary hover:translate-x-1 inline-block transition-all cursor-pointer">
                Accueil
              </Link>
            </li>
            <li>
              <Link to="/devis" className="text-gray-custom hover:text-secondary hover:translate-x-1 inline-block transition-all cursor-pointer">
                Devis en ligne
              </Link>
            </li>
            <li>
              <Link to="/rendez-vous" className="text-gray-custom hover:text-secondary hover:translate-x-1 inline-block transition-all cursor-pointer">
                Rendez-vous
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-lg sm:text-xl uppercase tracking-wider mb-4 sm:mb-6">Suivez-nous</h4>
          <ul className="space-y-4 sm:space-y-5">
            <li>
              <a href="https://www.instagram.com/eht_automobile?igsh=MXFvcml1NWlqNW1hcw==" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-custom hover:text-secondary transition-all group cursor-pointer">
                <i className="ri-instagram-line text-xl sm:text-2xl group-hover:rotate-12 transition-transform"></i>
                <span>Instagram</span>
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/share/1JdkAoe5NL/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-custom hover:text-secondary transition-all group cursor-pointer">
                <i className="ri-facebook-circle-line text-xl sm:text-2xl group-hover:rotate-12 transition-transform"></i>
                <span>Facebook</span>
              </a>
            </li>
            <li>
              <a href="https://share.google/7AgZ5TOY2hefuJluH" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-custom hover:text-secondary transition-all group cursor-pointer">
                <i className="ri-google-line text-xl sm:text-2xl group-hover:rotate-12 transition-transform"></i>
                <span>Google Business</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 sm:mt-16 pt-6 sm:pt-8 border-t border-gray-800 relative z-10">
        <p className="text-gray-custom text-xs sm:text-sm text-center px-4">
          © 2025 EHT AUTOMOBILE - Le Creusot | Tous droits réservés
        </p>
      </div>
    </footer>
  );
}
